import React from "react";
import { Text, View } from "@react-pdf/renderer";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";
import SelectGroup from "../../../exportacion_react_pdf/SelectGroup";

// Define el documento
const ExportPaso4 = ({ formData = {}, styles = {} }) => (
  <>
    {/* Producto Representativo */}
    <View style={styles.section}>
      <Text style={styles.title_1}>IV. Mercadeo y ventas</Text>

      <CheckboxGroup
        label="¿El proyecto productivo tiene claramente definidos e identificados a sus clientes?"
        selectedValue={formData?.tiene_identificado_clientes || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="Teniendo en cuenta la formulación del proyecto, al día de hoy, sus clientes han:"
        selectedValue={formData?.dia_hoy_clientes_han || ""}
        options={["Disminuido", "Permaneció igual", "Aumento"]}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿En ejercicio de la actividad económica, sabe cuál es la competencia directa? (qué productos venden, a quiénes, precios de venta, etc.)"
        selectedValue={formData?.competente_directo || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿Conoce cuáles son los elementos diferenciadores de los productos o servicios frente a los competidores? (calidad, precio, tiempos de entrega)"
        selectedValue={formData?.elementos_diferenciadores || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿El proyecto productivo utiliza algún medio para atraer nuevos clientes o mercadear productos (vallas, avisos, volantes, promociones)?"
        selectedValue={formData?.medio_atraer_clientes || ""}
      ></CheckboxGroup>

      <SelectGroup
        label="¿El proyecto productivo conoce las temporadas del año que se pueden aprovechar para aumentar las ventas a partir de los ciclos de producción? Para las unidades agropecuarias, saben de los cambios climáticos (estaciones del año para cultivar y cosechar) que le permite garantizar la calidad de la cosecha o de los productos que comercializará."
        selectedValue={formData?.temporadas_aumentar_ventas || []}
      ></SelectGroup>

      <TextAreaLabel
        label={
          "¿Conjuntamente entre la persona en reincorporación y el asesor identifiquen una fortaleza representativa del proyecto en temas de mercadeo y ventas?"
        }
        value={formData?.fortaleza_representativa_mercadeo_ventas || ""}
      ></TextAreaLabel>

      <TextAreaLabel
        label={
          "¿Conjuntamente entre la persona en reincorporación y el asesor identifiquen una debilidad representativa del proyecto temas de Mercadeo y Ventas?"
        }
        value={formData?.debilidad_representativa_mercadeo_ventas || ""}
      ></TextAreaLabel>
    </View>
  </>
);

export default ExportPaso4;
